// ════════════════════════════════════════════════════════════════════
// Saldo de un pedido — fuente única de verdad
//
// Un abono del cliente puede quedar guardado en DOS campos:
//   ordenes_pedido.abonos            → registrado en CrearDocumento o Pagos Pendientes
//   ordenes_pedido.abonos_recepcion  → cobrado el día del evento, en Recepción
//
// Los dos son plata que el cliente ya pagó. Antes cada módulo copiaba el
// cálculo y leía solo el primero, así que un pedido cobrado en Recepción
// aparecía como si el cliente todavía debiera.
// ════════════════════════════════════════════════════════════════════

// ⚠️ Number(ab?.valor) || 0, NO Number(ab.valor || ab || 0):
// si un abono tiene el valor vacío, la segunda forma cae en el objeto
// entero, devuelve NaN, y un solo NaN invalida TODA la suma del pedido.
export const sumarAbonos = (lista) =>
  (lista || []).reduce((acc, ab) => acc + (Number(ab?.valor) || 0), 0);

export const totalNetoPedido = (orden) =>
  Number(orden?.total_neto || orden?.total || 0);

export const totalPagado = (orden) =>
  sumarAbonos(orden?.abonos) + sumarAbonos(orden?.abonos_recepcion);

export const saldoPedido = (orden) =>
  Math.max(0, totalNetoPedido(orden) - totalPagado(orden));

export const estaPagado = (orden) => {
  const neto = totalNetoPedido(orden);
  return neto > 0 && saldoPedido(orden) === 0;
};